import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchColorDetailsWithoutId } from '../../../colorDetails/colorDetails.actions';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import {
    fetchSupplierListBasedOnProgramDC,
    fetchYarnPOProgramDropdown,
    fetchYarnPOSalesOrderDropdown
} from '../../YarnPO/yarnPO/yarnPO.actions';
import { fetchDyeingDCDetailsById } from '../dyeingDCDetails/dyeingDCDetails.actions';
import {
    CREATE_DYEING_DC_FAILURE,
    CREATE_DYEING_DC_REQUEST,
    CREATE_DYEING_DC_SUCCESS,
    CREATE_USER_FORM_DYEING_DC,
    DELETE_DYEING_DC_FAILURE,
    DELETE_DYEING_DC_REQUEST,
    DELETE_DYEING_DC_SUCCESS,
    FETCH_SINGLE_DYEING_DC_FAILURE,
    FETCH_SINGLE_DYEING_DC_REQUEST,
    FETCH_SINGLE_DYEING_DC_SUCCESS,
    FETCH_DYEING_DC_FAILURE,
    FETCH_DYEING_DC_REQUEST,
    FETCH_DYEING_DC_SUCCESS,
    DYEING_DC_USERFORM_RESET,
    UPDATE_DYEING_DC_FAILURE,
    UPDATE_DYEING_DC_REQUEST,
    UPDATE_DYEING_DC_SUCCESS,
    DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_DYEING_DC_INVOICE_REQUEST,
    FETCH_DYEING_DC_INVOICE_SUCCESS,
    FETCH_DYEING_DC_INVOICE_FAILURE,
    FETCH_DYEING_DC_STYLE_REQUEST,
    FETCH_DYEING_DC_STYLE_SUCCESS,
    FETCH_DYEING_DC_STYLE_FAILURE,
    CHECK_ALL_UPDATE_REQUEST_DYEING,
    CHECK_ALL_UPDATE_SUCCESS_DYEING,
    CHECK_ALL_UPDATE_FALIURE_DYEING,
    CLOSE_BTN_POST_REQUEST_DYEING,
    CLOSE_BTN_POST_SUCCESS_DYEING,
    CLOSE_BTN_POST_FALIURE_DYEING,
    DYEING_DC_DIA_REQUEST,
    DYEING_DC_DIA_SUCCESS,
    DYEING_DC_DIA_FALIURE,
    DYEING_DC_PROGRAM_ID_REQUEST,
    DYEING_DC_PROGRAM_ID_SUCCESS,
    DYEING_DC_PROGRAM_ID_FAILURE
} from './dyeingDC.actionsType';

// FETCH PROPERTY MASTER
export let fetchDyeingDC = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCMasterGET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_DYEING_DC_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createDyeingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_DYEING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createDyeingDCMaster = (formData, modalClose, startDate, endDate, isDetail, unitId, userform, id, resetData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKSupplierID: parseInt(userform.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSaleOrderdetail: 0,
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData?.fldDeliveryStartDate ? formData.fldDeliveryStartDate : today.toISOString(),
        fldDeliveryEndDate: formData?.fldDeliveryEndDate ? formData.fldDeliveryEndDate : today.toISOString(),
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: userform.fldIsInHouseDelivery ? 0 : parseInt(userform.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(userform.fldFKDeliveryAt),
        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: '',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: '',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldProcessess: userform?.fldProcessess ? userform.fldProcessess.join(', ') : '',
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKMainstyle: parseInt(formData.fldFKMainstyle),
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldIsReprocess: formData.fldIsReprocess,
        fldIsWithCost: formData.fldIsReprocess === false ? true : formData.fldIsWithCost,
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.dyeingDCMasterPOST}`,
        responseTypeRequest: CREATE_DYEING_DC_REQUEST,
        responseTypeSuccess: CREATE_DYEING_DC_SUCCESS,
        responseTypeFailure: CREATE_DYEING_DC_FAILURE,
        resetFormData: isDetail ? DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : DYEING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        // getAllData: fetchDyeingDC(startDate, endDate, unitId),
        singlApiArray: [fetchDyeingDC(startDate, endDate, unitId)]
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleDyeingDCMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_DYEING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_DYEING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_DYEING_DC_FAILURE,
        singlApiArray: [
            // fetchCommonPropertyById(28),
            // fetchSeasonMaster(),
            // fetchPartyDetailsData(),
            // fetchCommonPropertyById(52),
            // fetchCommonPropertyById(46),
            // fetchCommonPropertyById(72),
            // fetchUnitMaster(),
            // fetchYarnPOProgramDropdown('TblDyeingDC'),
            // fetchSupplierListBasedOnProgramDC('TblDyeingDC'),
            // fetchYarnPOSalesOrderDropdown(),
            // fetchDyeingDCStyleGetList(),
            fetchColorDetailsWithoutId()
        ]
    };
    return axiosCall(config);
};

export let getDyeingDCInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_DYEING_DC_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_INVOICE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER

export let updateDyeingDCMaster = (formData, id, startDate, endDate, unitId, userform,
    resetData

) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKSaleOrderdetail: 0,
        // fldProcessess: userform?.fldProcessess ? userform?.fldProcessess?.toString() : '',
        // fldProcessess: userform?.fldProcessess.toString(),

        fldProcessess: resetData === true && userform?.fldProcessess ? userform.fldProcessess.join(', ')
            : userform?.fldProcessess,
        fldFKSupplierID: parseInt(userform.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldFKMainstyle: parseInt(formData.fldFKMainstyle),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: userform.fldIsInHouseDelivery ? 0 : parseInt(userform.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(userform.fldFKDeliveryAt),
        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,

        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,

        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),

        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldIsAuthorized: formData.fldIsAuthorized,
        fldIsReprocess: formData.fldIsReprocess,
        fldIsWithCost: formData.fldIsReprocess === false ? true : formData.fldIsWithCost,
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.dyeingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_DYEING_DC_REQUEST,
        responseTypeSuccess: UPDATE_DYEING_DC_SUCCESS,
        responseTypeFailure: UPDATE_DYEING_DC_FAILURE,
        resetFormData: DYEING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchDyeingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let updateCheckAllDyeing = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconDyeing}/?FldFKPoNo=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST_DYEING,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS_DYEING,
        responseTypeFailure: CHECK_ALL_UPDATE_FALIURE_DYEING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let PostCloseIconApiDyeing = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconDYE}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_DYEING,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_DYEING,
        responseTypeFailure: CLOSE_BTN_POST_FALIURE_DYEING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

// DELETE PROPERTY MASTER
export let deleteDyeingDCMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.dyeingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_DYEING_DC_REQUEST,
        responseTypeSuccess: DELETE_DYEING_DC_SUCCESS,
        responseTypeFailure: DELETE_DYEING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchDyeingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchDyeingDCStyleGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCStyleMasterGET}?ActionCode=DYD`,
        responseTypeRequest: FETCH_DYEING_DC_STYLE_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_STYLE_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let fetchDyeingDCDetailsDiaFrmStyle = (style, fabGrp, yarnCnt, fabric, fldId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCDetailsDiaFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&fldId=${fldId}`,
        responseTypeRequest: DYEING_DC_DIA_REQUEST,
        responseTypeSuccess: DYEING_DC_DIA_SUCCESS,
        responseTypeFailure: DYEING_DC_DIA_FALIURE
    };
    return axiosCall(config);
};

export let getStyleProgramId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCMasterGETID}/${id}`,
        responseTypeRequest: DYEING_DC_PROGRAM_ID_REQUEST,
        responseTypeSuccess: DYEING_DC_PROGRAM_ID_SUCCESS,
        responseTypeFailure: DYEING_DC_PROGRAM_ID_FAILURE
    };
    return axiosCall(config);
};
